import React,{useState}  from 'react';
import {useSwipeable} from "react-swipeable"
import Slide from '@mui/material/Slide';
import AuthContext from "./auth/Context";
function Swipeable({onSwipedLeft,onSwipedRight,style,children}){
  const context = React.useContext(AuthContext);
  
  if (!("ontouchstart" in document.documentElement) || !context.queryParams.for_agent || context.queryParams.swipeable==false || context.queryParams.swipeable=="false"){
    return <div style={style}>{children}</div>
  }

  let [out,setOut] = useState(false)
  let [direct,setDirect] = useState("")
  const handlers = useSwipeable({
    onSwipedLeft: () => {
      if(onSwipedLeft){
        setDirect("left");
        setOut(!out)
      }
    },
    onSwipedRight: () => {
      if(onSwipedRight){
        setDirect("right");
        setOut(!out)
      }
    },
    swipeDuration: 500,
    preventScrollOnSwipe: false,
    trackMouse: false
  });
  return (
      <div {...handlers} style={style}>
        <Slide in={!out} direction="left" style={{ transitionDelay: out?'0ms':'0ms' }} addEndListener={()=>{
          if(out){
            if(direct=="left" && onSwipedLeft){
              onSwipedLeft();
            }
            if(direct=="right" && onSwipedRight){
              onSwipedRight();
            }
          }
        }}>
          <div style={{height:"100%",...style}}>
            {children}
          </div>
        </Slide>
      </div>
    
  )
}
export default Swipeable